// extracted by mini-css-extract-plugin
export default {"task-active":"mVZzWvXsxcDewUG9F8pa","slide-up-down":"FqXAATwMTezTCPZ3FMrN","author":"k0y24pSkPIRuAJRdtJnI","total":"Jh0W6vbIggwxpBeebGIJ"};